/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social/twitterFull': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 19.5',
    data: '<path pid="0" d="M7.5 19.5c9.1 0 14-7.5 14-14v-.6c1-.7 1.8-1.6 2.5-2.5-.9.4-1.9.7-2.8.8 1-.6 1.8-1.6 2.2-2.7-1 .6-2 1-3.1 1.2-1.9-2-5-2.1-7-.2-1.3 1.2-1.8 3-1.4 4.7C7.9 5.8 4.2 4 1.7.9.4 3.1 1 6 3.2 7.5c-.8-.1-1.6-.3-2.2-.6V7c0 2.3 1.7 4.4 4 4.8-.7.2-1.5.2-2.2.1.6 2 2.5 3.4 4.6 3.4-1.7 1.4-3.9 2.1-6.1 2.1-.4 0-.8 0-1.2-.1 2.2 1.4 4.8 2.2 7.4 2.2"/>'
  }
})
